import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html'
})
export class ErrorPageComponent implements OnInit {

  translations = new Map<string, { title: string; text: string; button: string; }>();
  currentLanguage = 'en';

  ngOnInit(): void {
    const mail = 'hello@door-vision.com';
    const mailLink = `<a href="mailto:${mail}">${mail}</a>`;
    this.translations.set('en', {
      title: 'Unexpected Error',
      text: `An unexpected error occurred. Please try again later.<br>If the problem persists please contact us: ${mailLink}`,
      button: 'Refresh'
    });
    this.translations.set('de', {
      title: 'Unerwarteter Fehler',
      text: `Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.<br>Sollte das Problem weiterhin bestehen, kontaktieren Sie uns bitte: ${mailLink}`,
      button: 'Aktualisieren'
    });

    this.currentLanguage = this.getExistingLanguage();
  }

  getLanguages(): Array<string> {
    let browserLang: string[] | undefined = window.navigator?.languages as string[];
    // @ts-ignore
    browserLang = browserLang || [window.navigator.language] || [window.navigator.browserLanguage] || [window.navigator.userLanguage] || ['en'];

    // normalize e.g.: en-US to en or de_DE to de
    browserLang = browserLang.map(s => s.split('-')[0]);
    browserLang = browserLang.map(s => s.split('_')[0]);

    return browserLang;
  }

  getExistingLanguage(): string {
    for (const lang of this.getLanguages()) {
      if (this.translations.has(lang)) {
        return lang;
      }
    }
    const [firstKey] = this.translations.keys();
    return firstKey;
  }

  getTitle(): string {
    return this.translations.get(this.currentLanguage)!.title;
  }

  getText(): string {
    return this.translations.get(this.currentLanguage)!.text;
  }

  getButtonText(): string {
    return this.translations.get(this.currentLanguage)!.button;
  }
}
